import type { SyntheticEvent } from 'react';

/**
 * Portaled overlays still bubble React events through their React parents.
 * Dialogs mounted inside table rows must not activate the row.
 */
export function stopRowActivation<E extends SyntheticEvent>(
  event: E,
  extra?: (event: E) => void,
) {
  event.stopPropagation();
  extra?.(event);
}
